import React, { useState } from 'react';
import { ActionButton } from '@able/react';

const ExpandableText = React.memo(({ text, charLimit = 1000, className = '' }) => {
    const [expanded, setExpanded] = useState(false);
    const isLong = text.length > charLimit;
    const firstSentence = isLong ? (text.match(/.*?\./)?.[0].trim() || text.slice(0,charLimit).trim()) : text;
    const displayText = isLong && !expanded ? firstSentence : text;

    return (
        <span className={className}>
            {displayText}
            {isLong && (
                <>
                    &nbsp;
                    <ActionButton
                        className="expand-item"
                        element="button"
                        label={expanded ? "Read less" : "Read more"}
                        variant="LowEmphasis"
                        onClick={() => setExpanded(!expanded)}
                    />
                </>
            )}
        </span>
    );
});

export default ExpandableText;
